import React from "react";

const BookingRefContext = React.createContext("");
export default BookingRefContext;
